/**
 * @file
 * Pluxee ellipsis script.
 */

(function ($) {
    'use strict';
    Drupal.behaviors.pluxeeEllipsis = {
        attach: function (context, settings) {
            function addEllipsis($elements) {
                $elements.each(function () {
                    const elementLineHeight = parseFloat(getComputedStyle(this).lineHeight);
                    var elementMaxHeight;
                    if (window.innerWidth < 1024) {
                        elementMaxHeight = elementLineHeight * 3;
                    }
                    else {
                        elementMaxHeight = elementLineHeight * 2;
                    }
                    this.style.maxHeight = "none";
                    if (this.offsetHeight > elementMaxHeight) {
                        this.style.maxHeight = elementMaxHeight + "px";
                        this.classList.add("pluxee-ellipsis-active");
                    }
                    else {
                        this.classList.remove("pluxee-ellipsis-active");
                    }
                });
            }
            var $elements = [];
            $(document).ready(function () {
                $elements = $(".pluxee-ellipsis");
                addEllipsis($elements);
            });
            $(window).on("resize", function () {
                addEllipsis($elements);
            });
        }
    };
})(jQuery);
